import { withTranslation } from "react-i18next";
import { SidebarSAdmin } from "./sidebar/sidebarSAdmin.js";
import { SidebarMenuCompanyAdmin_LKSG, SidebarMenuSupplierAdmin_LKSG } from "./sidebar/sidebar_LKSG.js";
import { USER_ROLE } from "./common.js";
export function SidebarMenu({ t }, code, userType) {  
  if (userType === "SUPER_ADMIN") {
    return SidebarSAdmin({ t });
  } else {
    return SidebarMenuCompanyAdmin_LKSG({ t });
  } 
  //********************these are the old permissions before introducing keyclock ***************************** */
  // else if (userType === "SUPPLIER_ADMIN") {
  //   switch (code) {
  //     case "LKSG":
  //       return SidebarMenuSupplierAdmin_LKSG({ t });
  //     case "VSOTR":
  //       return SidebarMenuSupplierAdmin_LKSG({ t });
  //     case "FINANCIAL_RISK":
  //       return SidebarMenuSupplierAdmin_LKSG({ t });
  //     default:
  //       return SidebarMenuSupplierAdmin_LKSG({ t });
  //   }
 // }
}
